module.exports = __webpack_public_path__ + "media/images/flags/mr-0a8c0e2bcdcad197323fe9f47fd3be02.svg";